import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: '404',
    redirect: { name: 'invoices' }
  },
  {
    path: '/',
    name: 'login',
    component: Login,
    beforeEnter: guardLogin

  },
  {
    path: '/invoices',
    name: 'invoices',
    component: () => import(/* webpackChunkName: "invoices" */ '../views/Invoices'),
    beforeEnter: guardRoute,
  },
  {
    path: '/invoicee/:id',
    name: 'invoicee',
    component: () => import(/* webpackChunkName: "invoicee" */ '../views/Invoicee'),
    beforeEnter: guardRoute,
  },
]

function guardRoute(to, from, next) {
  const isLoggedIn = store.getters.isLoggedIn
  if (!isLoggedIn) {
    const path = to.path
    next({
      name: 'login',
      params: { redirect: to.path }
    })
  } else {
    next()
  }
}
function guardLogin(to, from, next) {
  const isLoggedIn = store.getters.isLoggedIn
  if (isLoggedIn) {
    const path = to.path
    next({ name: 'invoices' })
  } else {
    next()
  }
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
